var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThumbsUpFilled = function SvgThumbsUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.527 1A2.1 2.1 0 0 0 9.66 2.148l-4.357 8.536H2.1c-1.16 0-2.099.949-2.099 2.119v9.079A2.107 2.107 0 0 0 2.099 24h16.398c2.223 0 4.113-1.639 4.447-3.857l1.004-6.657c.414-2.748-1.693-5.223-4.447-5.223h-5.237l.528-3.421C15.104 2.82 13.55 1 11.528 1Zm-6.73 11.5v9.684H2.1a.301.301 0 0 1-.3-.302v-9.08c0-.166.134-.302.3-.302h2.699Z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsUpFilled;